"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const InviteActions_1 = __importDefault(require("../../actions/InviteActions"));
const InviteContainer_1 = __importDefault(require("./InviteContainer"));
const InviteStageStyled_1 = __importDefault(require("./InviteStageStyled"));
const Message_1 = __importDefault(require("../../components/message/Message"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_1 = __importDefault(require("react"));
const SquareButton_1 = __importDefault(require("../squareButton/SquareButton"));
const react_router_1 = require("react-router");
const route_1 = require("../../utils/route");
class InviteSuccess extends react_1.default.Component {
    constructor() {
        super(...arguments);
        this.handleSendMore = () => {
            InviteActions_1.default.reset();
        };
        this.handleFinish = () => {
            InviteActions_1.default.reset();
            const path = this.props.inviteStore.prevPath;
            if (path) {
                this.props.history.push(path);
            }
            else {
                this.props.history.push(route_1.generateRouteTo('/', this.props.location));
            }
        };
    }
    render() {
        return (react_1.default.createElement(InviteStageStyled_1.default, { className: "successStage" },
            react_1.default.createElement(InviteContainer_1.default, { className: "InviteContainer" },
                react_1.default.createElement("h1", { className: "site-block-page-title" },
                    react_1.default.createElement(Message_1.default, { code: "epic.code.invite.title" })),
                react_1.default.createElement("div", { className: "site-block" },
                    react_1.default.createElement("div", { className: "site-block-header" },
                        react_1.default.createElement("h1", { className: "site-block-title" },
                            react_1.default.createElement(Message_1.default, { code: "epic.code.invite.success.title" })),
                        react_1.default.createElement("p", { className: "text-center" },
                            react_1.default.createElement(Message_1.default, { code: "epic.code.invite.success.msg" })),
                        react_1.default.createElement("div", { className: "clearfix" })),
                    react_1.default.createElement("div", { className: "buttonContainer" },
                        react_1.default.createElement(SquareButton_1.default, { handleClick: this.handleFinish, config: { buttonStyle: 'btn-primary', inline: true, width: '260px' } },
                            react_1.default.createElement(Message_1.default, { code: "epic.common.finish" })),
                        react_1.default.createElement(SquareButton_1.default, { handleClick: this.handleSendMore, config: { buttonStyle: 'btn-default', inline: true, width: '260px' } },
                            react_1.default.createElement(Message_1.default, { code: "epic.code.invite.success.sendMore" })))))));
    }
}
InviteSuccess.propTypes = {
    history: prop_types_1.default.object,
    inviteStore: prop_types_1.default.object,
    location: prop_types_1.default.object
};
exports.default = react_router_1.withRouter(InviteSuccess);
//# sourceMappingURL=InviteSuccess.js.map